import { styled, SxProps, Theme } from "@mui/material/styles";
import { Box } from "@mui/system";
import { forwardRef } from "react";
import type { ReactNode } from "react";
import SimpleBar, { Props } from "simplebar-react";

interface ScrollbarProps extends Props {
  children?: ReactNode;
  sx?: SxProps<Theme>;
}

export const Scrollbar = forwardRef<HTMLDivElement, ScrollbarProps>(
  ({ children, sx, ...other }, ref) => {
    return (
      <Box component={StyledSimpleBar} ref={ref} sx={sx} {...other}>
        {children}
      </Box>
    );
  },
);

export const StyledSimpleBar = styled(SimpleBar)(({ theme }) => ({
  maxHeight: "100%",
  "& .simplebar-scrollbar": {
    "&:before": {
      backgroundColor: theme.palette.grey[600],
      opacity: 0,
    },
    "&.simplebar-visible:before": {
      opacity: 0.5,
    },
  },
  "& .simplebar-track.simplebar-vertical": {
    width: 9,
  },
  "& .simplebar-track.simplebar-horizontal": {
    display: "none",
  },
}));
